import { useMemo, useState } from "react";
import { gossipCards, type TagType } from "@/mocks/gossipData";

const filters: { key: "全部" | TagType; icon: string }[] = [
  { key: "全部", icon: "ri-donut-chart-line" },
  { key: "约会", icon: "ri-map-pin-time-line" },
  { key: "恋爱", icon: "ri-heart-line" },
  { key: "官宣", icon: "ri-megaphone-line" },
  { key: "分手", icon: "ri-rainy-line" },
];

const tagStyle: Record<TagType, string> = {
  约会: "bg-accent-100 text-accent-800",
  恋爱: "bg-secondary-100 text-secondary-800",
  官宣: "bg-primary-100 text-primary-700",
  分手: "bg-foreground-100 text-foreground-600",
};

export default function GossipChannel() {
  const [active, setActive] = useState<"全部" | TagType>("全部");

  const list = useMemo(
    () => (active === "全部" ? gossipCards : gossipCards.filter((c) => c.tag === active)),
    [active]
  );

  return (
    <section id="gossip" className="w-full py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-7">
          <div>
            <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-semibold tracking-widest">
              <i className="ri-newspaper-line"></i> GOSSIP CHANNEL
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-extrabold text-foreground-950">绯闻频道</h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-lg">
              按情感走向标签分类浏览，约会实锤、恋情曝光、官宣与分手一目了然，每一条都附来源与热度。
            </p>
          </div>

          <div
            className="inline-flex items-center bg-background-100 rounded-full p-1 self-start lg:self-auto flex-wrap"
            role="tablist"
            aria-label="绯闻分类筛选"
          >
            {filters.map((f) => (
              <button
                key={f.key}
                role="tab"
                aria-selected={active === f.key}
                onClick={() => setActive(f.key)}
                className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                  active === f.key
                    ? "bg-primary-600 text-background-50 font-medium"
                    : "text-foreground-700 hover:text-primary-600"
                }`}
              >
                <i className={f.icon}></i>
                {f.key}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((card) => (
            <article
              key={card.id}
              className="group rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors flex flex-col"
            >
              <a href="#gossip" className="relative block overflow-hidden aspect-[4/3]" aria-label={card.title}>
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <span className={`absolute top-3 left-3 text-xs font-medium rounded px-2 py-1 ${tagStyle[card.tag]}`}>
                  {card.tag}
                </span>
              </a>
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <div className="flex items-center gap-2 text-[11px] text-foreground-500 mb-2 flex-wrap">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-flashlight-fill text-accent-500"></i>
                    {card.source}
                  </span>
                  <span>·</span>
                  <span>{card.time}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-700 transition-colors">
                  <a href="#gossip">{card.title}</a>
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600 line-clamp-2">{card.summary}</p>
                <div className="mt-4 pt-3 border-t border-background-100 flex items-center justify-between text-xs text-foreground-500 mt-auto">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i> {card.read}
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-600 group-hover:gap-2 transition-all">
                    围观讨论 <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-9 text-center">
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 text-foreground-800 text-sm font-medium px-6 h-11 hover:border-primary-300 hover:text-primary-600 transition-colors"
          >
            更多瓜料持续上新，订阅早报第一时间提醒
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}